export default __webpack_public_path__ + "static/media/ImpactoZero_Logo_COLOR.b948006c.png";